<div class="tw-flex tw-flex-col tw-gap-3 tw-flex-1 tw-min-w-0">
  <div class="tw-flex tw-items-end tw-gap-2 tw-mb-1">
    <div>
      <label
        for="acct-dedup-style-select"
        class="tw-block tw-text-sm tw-font-medium tw-text-dt-text-secondary tw-mb-1"
      >
        Duplicate style
      </label>
      <select
        id="acct-dedup-style-select"
        class="tw-rounded-md tw-border tw-border-dt-border-primary tw-bg-dt-surface-card tw-px-2 tw-py-2 tw-text-sm tw-text-dt-text-headings focus:tw-border-teal-500"
        [value]="selectedDedupStyle()"
        (change)="onDedupStyleChange($event)"
      >
        @for (style of dedupStyles; track style.value) {
          <option [value]="style.value">{{ style.label }}</option>
        }
      </select>
    </div>
    <span class="tw-text-xs tw-italic tw-text-dt-text-tertiary tw-max-w-xs tw-pb-1">
      {{ selectedDedupStyleDescription() }}
    </span>
    <button
      type="button"
      class="tw-border-none tw-bg-transparent tw-cursor-pointer tw-p-0 tw-pb-1 tw-flex tw-items-center"
      (click)="openDedupStyleInfoDialog()"
      title="More info about this duplicate style"
    >
      <svg class="tw-w-5 tw-h-5">
        <use xlink:href="images/sprite.svg#info" />
      </svg>
    </button>
  </div>

  <div class="tw-flex tw-gap-4 tw-w-full tw-max-w-4xl tw-mb-3 tw-items-end">
    <div class="tw-flex tw-items-end tw-gap-2 tw-shrink-0">
      <div>
        <label
          for="vault-cleanup-count"
          class="tw-block tw-text-sm tw-font-medium tw-text-dt-text-secondary tw-mb-1"
          >Count</label
        >
        <input
          id="vault-cleanup-count"
          type="number"
          min="1"
          step="1"
          autocomplete="off"
          class="tw-w-20 tw-rounded-md tw-border tw-border-dt-border-primary tw-bg-dt-surface-card tw-px-3 tw-py-2 tw-text-sm tw-text-dt-text-headings placeholder:tw-text-dt-text-disabled focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-teal-500/40 focus:tw-border-teal-500"
          placeholder="#"
          (input)="onCleanupCountInput($event)"
          (keydown.period)="$event.preventDefault()"
          (keydown.e)="$event.preventDefault()"
          (keydown.+)="$event.preventDefault()"
          (keydown.-)="$event.preventDefault()"
        />
      </div>
      <button
        type="button"
        mat-stroked-button
        color="warn"
        class="tw-text-sm"
        [disabled]="vaultDuplicateGroups().length === 0"
        (click)="performCleanup()"
      >
        {{ vaultCleanupButtonLabel() }}
      </button>
      <button
        type="button"
        mat-stroked-button
        color="warn"
        class="tw-text-sm"
        [disabled]="vaultDuplicateGroups().length === 0"
        (click)="removeAllDuplicates()"
      >
        Remove all duplicates
      </button>
    </div>
  </div>

  <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-mb-1">
    <mat-checkbox [checked]="vaultDuplicatesOnly()" (change)="onDuplicatesOnlyChange($event)">
      Duplicates only
    </mat-checkbox>
    <mat-checkbox [checked]="vaultNotDuplicatesOnly()" (change)="onNotDuplicatesOnlyChange($event)">
      Not duplicates
    </mat-checkbox>
  </div>

  <div class="tw-flex tw-flex-wrap tw-gap-4 tw-text-sm tw-mb-1">
    <span class="tw-text-dt-text-secondary">
      Total items: <span class="tw-font-medium">{{ vaultTotalItems() }}</span>
    </span>
    <span class="tw-text-dt-text-secondary">
      Unique: <span class="tw-font-medium">{{ vaultDisplayedUniqueCount() }}</span>
    </span>
    @if (vaultDuplicateGroups().length > 0) {
      <span class="tw-text-orange-600 tw-font-medium">
        {{ vaultDuplicateGroups().length }} item(s) with duplicates
      </span>
    }
  </div>

  <div
    appGlossScroll
    class="tw-flex tw-flex-col tw-border tw-border-dt-border-secondary tw-rounded-lg tw-overflow-y-auto tw-max-h-[28rem] tw-bg-dt-surface-elevated"
  >
    @for (group of vaultDisplayedItemGroups(); track group.contentHash) {
      <div
        class="tw-flex tw-items-start tw-gap-3 tw-px-3 tw-py-2 tw-border-0 tw-border-b tw-border-neutral-100 last:tw-border-b-0 hover:tw-bg-dt-surface-elevated/80"
        [class.tw-bg-orange-50]="group.count > 1"
      >
        <div class="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">
          <span class="tw-text-sm tw-font-mono tw-truncate">
            id: {{ group.representative.id }}
          </span>
          @if (group.count > 1) {
            <span class="tw-text-xs tw-text-orange-700 tw-font-semibold">
              {{ group.count }} copies
            </span>
          }
          <pre
            appGlossScroll
            class="tw-m-0 tw-mt-1 tw-text-xs tw-font-mono tw-max-h-24 tw-overflow-auto tw-p-2 tw-bg-dt-surface-sunken tw-rounded tw-whitespace-pre-wrap tw-break-words tw-text-dt-text-secondary"
            >{{ vaultItemSummary(group) }}</pre
          >
        </div>
        <div class="tw-flex tw-flex-col tw-gap-2 tw-shrink-0">
          @if (group.count > 1) {
            <button
              type="button"
              mat-stroked-button
              class="tw-text-xs"
              (click)="onItemClick(group)"
            >
              Remove duplicates
            </button>
            <button
              type="button"
              mat-button
              class="tw-text-xs"
              (click)="openDuplicatesModal(group)"
            >
              Show all
            </button>
          }
          <button type="button" mat-stroked-button class="tw-text-xs" (click)="openDetails(group)">
            Details
          </button>
        </div>
      </div>
    }
    @if (vaultDisplayedItemGroups().length === 0) {
      <p class="tw-text-dt-text-tertiary tw-text-sm tw-m-0 tw-p-3">
        @if (vaultDuplicatesOnly()) {
          No duplicate groups for this type.
        } @else if (vaultNotDuplicatesOnly()) {
          No non-duplicate groups for this type.
        } @else {
          No items for this type.
        }
      </p>
    }
  </div>
</div>
